/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconSpace = createReactComponent("outline", "space", "IconSpace", [["path", { "d": "M4 10v3a1 1 0 0 0 1 1h14a1 1 0 0 0 1 -1v-3", "key": "svg-0" }]]);

export { IconSpace as default };
//# sourceMappingURL=IconSpace.mjs.map
